import type { SVGProps } from 'react';
const SvgNavigation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#navigation_svg__a)">
      <path
        fill="currentColor"
        d="M12 2 4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2Z"
      />
    </g>
    <defs>
      <clipPath id="navigation_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNavigation;
